module.exports = __webpack_public_path__ + "img/P13-en.bd28360b.png";